import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: ProductImpressionTrackingInfo) => {
    const event: AnalyticsEvent<ProductImpressionTrackingInfo> = {
        event: EventType.ProductDetailImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};
